
import store from './store';
import html2canvas from 'html2canvas';

class CommonHelper {
    constructor() { }

    showLoading() {
        store.commit('set', ['setLoading', true]);
    }

    hideLoading() {
        store.commit('set', ['setLoading', false]);
    }

    screenshot(id, imageName) {
        this.showLoading();
        window.scrollTo(0,0);

        html2canvas(document.querySelector(`#${id}`), {
          allowTaint: true,
          useCORS: true,
          scale: 2,
          onrendered: function (canvas) {
              document.body.appendChild(canvas);
          },
          windowWidth: id === 'LinkedinPage' ? '2600px' : '2160px',
          windowHeight: id === 'LinkedinPage' ? '1456px' : '2700px',
        }).then(canvas => {
          document.body.appendChild(canvas)
          return canvas
        }).then((canvas) => { 
            this.hideLoading();
            const xhr = new XMLHttpRequest();
            const image = canvas.toDataURL('image/png');
            xhr.responseType = 'blob';
            xhr.overrideMimeType('image/png');
            xhr.onload = function () {
              let a = document.createElement('a');
              a.href = window.URL.createObjectURL(xhr.response);
              a.download = `${imageName}.png`;
              a.style.display = 'none';
              document.body.appendChild(a);
              a.click();
              a.remove();
              
              // Copy to clipboard
              canvas.toBlob((blob) => {
                if (navigator.clipboard && window.ClipboardItem) {
                  navigator.clipboard.write([
                    new window.ClipboardItem({ 'image/png': blob })
                  ]).then(() => {
                    console.log('Copied to Clipboard.');
                  }).catch(() => {
                    console.error('Permission Error copying to clipboard.');
                  });
                }
              }, 'image/png');
            };
            xhr.open('GET', image);
            xhr.setRequestHeader('Content-Disposition', `attachment; filename="${imageName}.png"`);
            xhr.send();
            canvas.remove();
        });
    }

    toLocaleUpperCase(text) {
        const lang = store.state.lang === 'tr' ? 'tr-TR' : 'en-US';
        return text.toLocaleUpperCase(lang);
    }

    getTemplateVars() {
      const template = store.state.template;
      const theme = store.state.theme;
      return store.state?.[template]?.[theme] || store.state.default[theme]
    }

    resolveCssVars(vars) {
      const resolved = {};
      const resolve = (value, visited = new Set()) => {
        if (!value || typeof value !== 'string') return value;
        return value.replace(/var\(--([^)]+)\)/g, (match, varName) => {
          const varKey = `--${varName}`;
          if (resolved[varKey]) return resolved[varKey];
          if (vars[varKey] && !visited.has(varKey)) {
            visited.add(varKey);
            return resolve(vars[varKey], visited);
          }
          return match;
        });
      };
      Object.keys(vars).forEach(key => {
        let value = vars[key];
        for (let i = 0; i < 10; i++) {
          const newValue = resolve(value);
          if (newValue === value) break;
          value = newValue;
        }
        resolved[key] = value;
      });
      return resolved;
    }

    getUsablePrevPeriod(val) {
      let year = Math.floor(val / 100);
      let month = val % 100;
    
      month -= 3;
    
      while (month <= 0) {
        month += 12;
        year--;
      }
    
      return year * 100 + month;
    }

    isPanelColumnAllZero(periodicDataItem, panelDefs) {
      if (!periodicDataItem || !panelDefs?.length) {
        return true;
      }

      return panelDefs.every(def => {
        const value = periodicDataItem[def.value];
        return value == null || value === '' || parseFloat(value) === 0;
      });
    }

    filterZeroPanelColumns(periodicData, panelDefs) {
      if (!periodicData?.length || !panelDefs?.length) {
        return periodicData || [];
      }

      return periodicData.filter(item => !this.isPanelColumnAllZero(item, panelDefs));
    }

    isMeaningfulPercentValue(percent) {
      if (!percent || percent === '-' || percent === 'A.D') {
        return false;
      }

      const numericValue = parseFloat(String(percent).replace('%', '').replace(',', '.'));
      return !isNaN(numericValue) && numericValue !== 0;
    }

    shouldShowPanelPercentColumn(panelDefs, getPercentValue) {
      if (!panelDefs?.length || typeof getPercentValue !== 'function') {
        return false;
      }

      return panelDefs.some(def => this.isMeaningfulPercentValue(getPercentValue(def)));
    }
}

export let commonHelper = new CommonHelper();